import { createSelector } from '@reduxjs/toolkit'

import { getLoanOfficer } from '../root.selectors'

export const getLoanOfficerList = createSelector(getLoanOfficer, (slice) => slice.list)
export const getAvailableOfficerList = createSelector(getLoanOfficer, (slice) => slice.available)
